import { PermissionEnum, Role } from '@orgbrain/roles';
import { CurrentUser, OrganizationWithRoles, Session } from '../..';

import * as Auth from '../org-auth-classes';

import {
  Code,
  CredentialEnum,
  ImplicitVotingSettings,
  OrgJurisdiction,
  OrgLanguage,
} from '@orgbrain/lib-data';

const organization: OrganizationWithRoles = {
  _id: '1234567890',
  extraSignaturesRequired: [],
  requiredId: [],
  availablePermissions: { [PermissionEnum.ADMIN]: true, [PermissionEnum.SHAREHOLDER]: true },
  availableRoles: { [Role.ADMIN]: true, [Role.SHAREHOLDER]: true },
  orderId: '',
  parentOrgNumber: '',
  parentOrganization: '',
  childOrgNumbers: [],
  orgId: '',
  name: '',
  clientId: '',
  deleted: false,
  language: OrgLanguage.EN,
  jurisdiction: OrgJurisdiction.NO,
  implicitVoting: ImplicitVotingSettings.IMPLICIT_FOR,
  roles: [],
  roleMap: {
    [Role.ADMIN]: { [PermissionEnum.ADMIN]: true, [PermissionEnum.SHAREHOLDER]: true },
    [Role.SHAREHOLDER]: { [PermissionEnum.SHAREHOLDER]: true },
  } as any,
};

const NOW = new Date();
const NOWSTRING = NOW.toISOString();

const emptySession: Session = {
  credentials: {} as any, //  The is an iso time stamp of when id was asserted.
  updatedAt: NOW,
  createdAt: NOW,
  inactivityPeriod: {} as any,
  id: '12345',
};

const user: CurrentUser = {
  client_admin: {},
  clientRoles: {},
  organizations: [organization],
  roles: {},
  orgIdToOrganizationIdMap: {},
  mfaMethods: [],
  superuser: false,
  acceptUsageTracking: undefined,
  acceptTerms: false,
  acceptMarketingEmail: false,
  sub: '',
  invited: undefined,
  createdAt: '',
  updatedAt: '',
  firstName: '',
  lastName: '',
  email: '',
  createdBy: '',
  session: emptySession,
};

export type MyTestType = {
  permissions: PermissionEnum[];
  currentUser: CurrentUser;
  organizationId: string;
  throwError: boolean;
  label: string;
  expectedCode: Code;
  fullExplainMode: boolean;
};

export function createTest({
  label,
  expectedCode,
  userHasCredentials,
  now = new Date(),
  inactivity = 0,
  requiredPermissions,
  userRoles,
  policy,
  fullExplainMode = false,
}: {
  label: string;
  expectedCode: Code;
  userHasCredentials: CredentialEnum[];
  now: Date;
  inactivity: number;
  requiredPermissions: PermissionEnum[];
  userRoles: Role[];
  policy: Auth.Policy;
  fullExplainMode?: boolean;
}): MyTestType {
  const protoTest: MyTestType = {
    permissions: [PermissionEnum.ADMIN],
    currentUser: user,
    organizationId: organization._id.toString(),
    throwError: true,
    label,
    expectedCode,
    fullExplainMode,
  };

  const test = structuredClone(protoTest);

  test.permissions = requiredPermissions;

  const credentials: { [key in CredentialEnum]: string } = {} as any;
  const inactivityPeriod: { [key: string]: number } = {};

  for (const credential of userHasCredentials) {
    credentials[credential] = now.toISOString();
    inactivityPeriod[credential] = inactivity;
  }

  const session: Session = {
    credentials, //  The is an iso time stamp of when id was asserted.
    updatedAt: now,
    createdAt: now,
    inactivityPeriod,
    id: '12345',
  };

  // const policy: OrganizationPolicy = {
  //   policyName,
  //   permissionRulesOverride,
  // };

  test.currentUser.organizations[0].roles = userRoles;
  test.currentUser.organizations[0].authPolicy = policy as any;
  test.currentUser.session = session;

  return test;
}
